import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width={19}
    height={19}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group 9">
      <path
        id="Rectangle 54 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.4 12.6883H1.6V16.9H3.4V12.6883ZM0 11.0883V18.5H5V11.0883H0Z"
        fill="#222A5C"
      />
      <path
        id="Rectangle 55 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4 7.39413H8.6V16.9H10.4V7.39413ZM7 5.79413V18.5H12V5.79413H7Z"
        fill="#222A5C"
      />
      <path
        id="Rectangle 56 (Stroke)"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4 2.1H15.6V16.9H17.4V2.1ZM14 0.5V18.5H19V0.5H14Z"
        fill="#222A5C"
      />
    </g>
  </svg>,
  "Usage"
);
